import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B">
        <path
          d="M 16 67 L 16 17 L 31 17 L 40 28 L 48 17 L 63 17 L 63 67 L 47 67 L 47 40 L 46 40 L 41 52 L 39 52 L 33 40 L 32 40 L 32 67"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 16 67 L 16 17 L 31 17 L 40 28 L 48 17 L 63 17 L 63 67 L 47 67 L 47 40 L 46 40 L 41 52 L 39 52 L 33 40 L 32 40 L 32 67"
      />
    </g>
  </svg>
);

export default IconLoader;
